import { Injectable, signal } from '@angular/core';

export class GlobalEvent {
  type: string = 'unknown';
  data: any = {};
  targetId?: string;
  timestamp: Date = new Date();

  constructor(type: string, data: any, targetId?: string) {
    this.type = type;
    this.data = data;
    this.targetId = targetId;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GlobalEventsService {
  private eventSignal = signal<GlobalEvent | null>(null);

  /**
   * Emit a global event.
   * @param event to emit
   */
  emitEvent(event: GlobalEvent): void;
  /**
   * Emit a global event.
   * @param type of the event to recognize the meaning
   * @param data to send
   * @param targetId of the receiving component
   */
  emitEvent(type: string, data: any, targetId?: string): void;
  /**
   * Emit a global event.
   * @param eventOrType event to emit or typeof event
   * @param data of the event
   * @param targetId of the event
   */
  emitEvent(eventOrType: GlobalEvent | string, data?: any, targetId?: string): void {
    if (typeof eventOrType === 'string') {
      // Fall: emitEvent(type, data, targetId)
      this.eventSignal.set(new GlobalEvent(eventOrType, data, targetId));
    } else {
      // Fall: emitEvent(event)
      this.eventSignal.set(eventOrType);
    }
  }

  /**
   * Get the event signal.
   * @returns the event signal
   */
  getEventSignal() {
    return this.eventSignal;
  }
}
